import { useSuspenseQuery } from '@tanstack/react-query'
import { paymentApi } from './paymentApi'
import { paymentQueryKeys } from './queryKeys'

export function usePaymentHistoryQuery() {
  return useSuspenseQuery({
    queryKey: paymentQueryKeys.history(),
    queryFn: () => paymentApi.history(),
  })
}
